'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _SearchIcon = require('./SearchIcon');

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _splitProps2 = require('./utils/splitProps');

var _splitProps3 = _interopRequireDefault(_splitProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale,
    textColors = _theme2.default.textColors,
    controlStateStyles = _theme2.default.controlStateStyles;


var styles = (0, _glamor.css)({
  backgroundColor: controlStateStyles.default.backgroundColor,
  color: controlStateStyles.default.color,
  border: controlStateStyles.default.border,
  transition: controlStateStyles.default.transition,
  '&:focus': {
    border: controlStateStyles.focus.border,
    boxShadow: controlStateStyles.focus.boxShadow
  }
});

function useControlSizes(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  var sizes = _theme2.default.controlSizes[size];

  return _extends({
    minHeight: sizes.minHeight,
    minWidth: sizes.minWidth,
    textStyle: sizes.textStyle,
    paddingX: size === 'small' ? minorScale(3) : majorScale(2),
    paddingLeft: size === 'small' ? majorScale(4) : minorScale(9)
  }, props);
}

var SearchInput = function SearchInput(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['className']);

  // Tries to treat this component as a single box
  var _splitProps = (0, _splitProps3.default)(useControlSizes(props), /margin|width|height|display|flex|alignItems|justifyContent|flexDirection|flexGrow|flexShrink/gi),
      matchedProps = _splitProps.matchedProps,
      unmatchedProps = _splitProps.unmatchedProps;

  return _react2.default.createElement(
    _Box2.default,
    _extends({ position: 'relative', display: 'flex' }, matchedProps),
    _react2.default.createElement(_SearchIcon2.default, {
      style: { pointerEvents: 'none' },
      size: 'small',
      position: 'absolute',
      top: '50%',
      marginLeft: props.size === 'small' ? minorScale(2) : minorScale(3),
      marginTop: majorScale(-1),
      fill: textColors.muted
    }),
    _react2.default.createElement(_Box2.default, _extends({ is: 'input', className: (0, _classnames2.default)('' + styles, className), flex: '1', rounded: true }, unmatchedProps))
  );
};

SearchInput.propTypes = _extends({}, _Box2.default.propTypes, {
  size: _propTypes2.default.oneOf(Object.keys(_theme2.default.controlSizes))
});

SearchInput.defaultProps = {
  size: 'default'
};

SearchInput.displayName = 'SearchInput';

exports.default = SearchInput;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/SearchInput.js
// module id = 1128
// module chunks = 0